import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "./commonSlice";
import { fromWithCompany, supabase } from "../config/supabaseClient";
import moment from "moment";
import {
  getDepartmentId,
  getLocalData,
  sendEmailNotification,
} from "../constant/utils/commonUtils";
import { currentDate } from "../constant/utils/datetimeUtils";
import { roleType, statuses, formatFormHistoryRole } from "../constant/constants";
import { fetchOrganogram, fetchOrganogramByDepartmentId } from "./organogramSlice";

export const fetchComments = createAsyncThunk(
  "comment/fetchComments",
  async (formId, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());
      // fetch comments based on form_id
      const { data, error } = await supabase
        .from("form_history")
        .select(
          "id, comment, action, created_at, old_value, new_value, form_status_id, role, created_by(first_name,last_name,data)"
        )
        .eq("form_id", formId)
        .order("created_at", { ascending: false });

      if (error) throw error;

      const formattedData = data.map((comment) => {
        return {
          comment: comment.comment,
          name:
            comment.created_by?.first_name && comment.created_by?.last_name
              ? comment.created_by.first_name + " " + comment.created_by.last_name
              : comment.created_by?.data?.Name || "-",
          action: comment.action,
          role: formatFormHistoryRole(comment.role),
          date: moment(comment.created_at).format("DD/MM/YYYY"),
          time: moment(comment.created_at).format("hh:mm A"),
          id: comment.id,
          old_value: comment.old_value,
          new_value: comment.new_value,
          form_status_id: comment.form_status_id,
          canView: !!(comment.old_value || comment.new_value),
        };
      });

      return formattedData;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const addComment = createAsyncThunk(
  "employees/addComment",
  async (
    { formId, comment, userid, formStatus },
    { rejectWithValue, dispatch }
  ) => {
    try {
      // if no data in organogramtable then return
      // const userData = getLocalData();

      // let deptId = null;
      // let dept_head = null;
      // if (formStatus !== "Request Edit") {
      //   const organogramData = await dispatch(
      //     fetchOrganogram(userData.company_id)
      //   );
      //   if (organogramData.payload.length) {
      //     const findDept = organogramData.payload.find(
      //       (item) => item.departmentId === to_id
      //     );

      //     // if (findDept?.approvalRequired) {
      //     //   deptId = findDept.departmentId;
      //     //   dept_head = findDept.departmentHeadId;
      //     // } else {
      //     const dept = getDepartmentId(
      //       findDept?.parentDepartmentId,
      //       organogramData.payload
      //     );
      //     deptId = dept?.deptId;
      //     dept_head = dept?.deptHeadId;
      //     // }
      //   }
      // }

      const userData = getLocalData();
      const { data, error } = await supabase
        .from("form_history")
        .insert({
          form_id: formId,
          comment: comment,
          type: "comment",
          created_by: userid,
          action: formStatus,
          role: userData?.role || null,
        })
        .select()
        .single();

      if (error) throw error;

      // Send Email Notification
      // let formAssignee = {};
      // if (deptId && dept_head && formStatus !== "Request Edit") {
      //   const { data: userEmail, error: userError } = await fromWithCompany("company_user")
      //     .select("email,role")
      //     .eq("emp_id", dept_head)
      //     .eq("status", statuses.ACTIVE)
      //     .single();
      //   if (userError) throw userError;
      //   formAssignee = {
      //     email: userEmail?.email,
      //     role: userEmail?.role,
      //   };
      // }
      // const { data: formData, error: formError } = await supabase
      //   .from("form_status")
      //   .insert({
      //     form_id: formId,
      //     status: formStatus,
      //     to_id: formStatus !== "Request Edit" ? deptId || null : null,
      //     role: deptId ? formAssignee?.role : "",
      //     created_at: currentDate(),
      //     created_by: userid,
      //     updated_at: currentDate(),
      //     updated_by: userid,
      //     from_id: userid,
      //   })
      //   .select()
      //   .single();
      // if (formStatus == "Request Edit") {
      //   const { data: userEmail, error: userError } = await supabase.from("training_survey_form").select("emp_id(email,role,emp_id)").eq("id", formId).single();
      //   if (userError) throw userError;
      //   formAssignee = {
      //     email: userEmail.emp_id.email,
      //     role: userEmail.emp_id.role,
      //     user_id: userEmail.emp_id.emp_id,
      //   };
      // }

      // if (formError) throw formError;
      // formAssignee?.email &&
      //   sendEmailNotification(
      //     formAssignee?.email,
      //     "For the Approval of Training Form",
      //     formStatus == "Request Edit"
      //       ? `Request Edit by ${getLocalData()?.first_name || "Unknown"}`
      //       : `Your form has been Approved.`
      //   );

      // const department = formData?.to_id && await dispatch(fetchOrganogramByDepartmentId(formData?.to_id));
      return {
        comment: data,
        // form_status: formData.status,
        // to_id: formData?.to_id,
        // dept_head_id: formStatus === "Request Edit" ? formAssignee.user_id : department?.payload?.dept_head_id,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const commentSlice = createSlice({
  name: "comment",
  initialState: {
    comments: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchComments.fulfilled, (state, action) => {
      state.comments = action.payload;
    });
    builder.addCase(fetchComments.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(addComment.fulfilled, (state, action) => {
      state.comments = [...state.comments, action.payload.comment];
    });
    builder.addCase(addComment.rejected, (state, action) => {
      state.error = action.payload;
    });
  },
});

export default commentSlice.reducer;
